module.exports = require("ts-morph");